import { render } from "./NeighborhoodUpdate.vue?vue&type=template&id=f9646210"
import script from "./NeighborhoodUpdate.vue?vue&type=script&lang=js"
export * from "./NeighborhoodUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__